import { createAction, createReducer } from "@reduxjs/toolkit"
import httpClient from "./httpClient"
import { checkUserType } from "../component/userUtils"
import { STAFF } from "../commons/userTypes"

export const GET_USERS_RESPONSE = createAction("GET_USERS_RESPONSE")
export const GET_PROFILE_RESPONSE = createAction("GET_PROFILE_RESPONSE")
export const SET_VISITOR_PROFILE = createAction("SET_VISITOR_PROFILE")

function fetchUsers(cancelToken) {
  return (dispatch) =>
    httpClient.get("/api/user", { cancelToken }).then(({ data }) => {
      dispatch(GET_USERS_RESPONSE(data))
    })
}

function fetchUserById(userId, cancelToken) {
  return (dispatch) =>
    httpClient.get(`/api/user/${userId}`, { cancelToken }).then(({ data }) => {
      // add staff property to user used in UserForm
      const user = {
        ...data,
        staff: checkUserType(data, STAFF)
      }
      dispatch(GET_PROFILE_RESPONSE(user))
    })
}

function fetchUserTags() {
  return () => httpClient.get("/api/tags").then((res) => res.data)
}

function saveOrUpdate(user) {
  return (dispatch) =>
    httpClient.post("/api/user", user).then(() => {
      if (user._id) {
        dispatch(fetchUserById(user._id))
      }
      dispatch(fetchUsers())
    })
}

function updateAll(users) {
  return () => httpClient.post("/api/user/many", users)
}

function fetchAssociatedDocuments(userIds) {
  const idsString = userIds.join(",")
  return async () => {
    const { data } = await httpClient.get(
      `/api/user/associated-documents?userIds=${idsString}`
    )
    return data
  }
}

function deleteUsers(userIds) {
  return async () =>
    Promise.allSettled(
      userIds.map(async (id) => httpClient.delete(`/api/user/${id}`))
    )
}

function setVisitorProfile(visitorProfile) {
  return (dispatch) => dispatch(SET_VISITOR_PROFILE(visitorProfile))
}

const initialState = {
  users: [],
  contacts: [],
  selected: undefined
}

const reducer = createReducer(initialState, {
  GET_USERS_RESPONSE: (state, { payload }) => ({
    ...state,
    users: payload
  }),
  GET_PROFILE_RESPONSE: (state, { payload }) => ({
    ...state,
    selected: payload
  }),
  SET_VISITOR_PROFILE: (state, { payload }) => ({
    ...state,
    visitorProfile: payload
  })
})

export default {
  initialState,
  actions: {
    fetchUsers,
    fetchUserById,
    fetchAssociatedDocuments,
    fetchUserTags,
    saveOrUpdate,
    deleteUsers,
    updateAll,
    setVisitorProfile
  },
  reducer
}
